import _ from 'lodash'
import { Vue, Component } from 'vue-property-decorator'

export interface SearchQuery {
  page?: number | string
  page_size?: number | string

  [key: string]: unknown
}

const defaultQuery = (query: SearchQuery = {}) => {
  return {
    page_size: query.page_size ? query.page_size : 15,
    page: query.page ? query.page : 1,
  }
}

@Component
export default class Search extends Vue {
  // this.query 是跟表单联动，cloneQuery 不联动，根据场景选择使用哪个
  // 一般执行搜索与重置时用 this.query；分页那里用 this.cloneQuery
  query = {} // 页面会有自定义的 query
  cloneQuery = {}

  mounted(): void {
    this._searchMounted()
  }

  /**
   * 搜索组件的 change 事件回调函数
   */
  handleSearch(formValue: SearchQuery): void {
    this.query = this._cookQuery(
      // 为了保证每次搜索都回归第一页
      Object.assign({}, this.query, formValue, defaultQuery(this.query), {
        page: 1,
      }),
    )
    this.$router.push({ name: this.$route.name, query: this.query })
  }

  /**
   * el-pagination 的 size-change 事件回调函数
   */
  handleSizeChange(pageSize: string | number): void {
    this.query = this._cookQuery(
      Object.assign({}, this.cloneQuery, this.$route.query || {}, {
        page: 1,
        page_size: pageSize,
      }),
    )
    this.$router.push({
      name: this.$route.name,
      query: this.query,
    })
  }

  // handleSizeChange(pageSize: string | number): void {
  //   this.$router.push({
  //     name: this.$route.name,
  //     query: Object.assign({}, this.cloneQuery, this.$route.query || {}, {
  //       page: 1,
  //       page_size: pageSize
  //     })
  //   })
  // }

  /**
   * el-pagination 的 current-change 事件回调函数
   */
  handleCurrentChange(page: string | number): void {
    this.query = this._cookQuery(
      Object.assign({}, this.cloneQuery, this.$route.query || {}, {
        page,
      }),
    )
    this.$router.push({
      name: this.$route.name,
      query: this.query,
    })
  }

  // handleCurrentChange(page: string | number): void {
  //   this.$router.push({
  //     name: this.$route.name,
  //     query: Object.assign({}, this.cloneQuery, this.$route.query || {}, {
  //       page
  //     })
  //   })
  // }

  /**
   * 搜索组件的 reset 事件回调函数
   */
  handleResetSearch(): void {
    this.query = this._cookQuery(
      Object.assign({}, this.query, defaultQuery(this.query), {
        page: 1,
        page_size: 15,
      }),
    )
    this.$router.push({ name: this.$route.name, query: this.query })
  }

  /**
   * 搜索组件的 change 事件回调函数
   * 当默认的方法无法满足需求场景时，就需要调用 search 方法
   */
  search(formValue: SearchQuery): void {
    this.query = this._cookQuery(
      Object.assign({}, this.query, defaultQuery(this.query), formValue),
    )
    this.$router.push({ name: this.$route.name, query: this.query })
  }

  _cookQuery(query: SearchQuery): SearchQuery {
    const isNumber = (value: string) => /^[1-9]+$/.test(value)

    // 将查询参数重全部是数字的字符串的类型转换为 number 类型，一般场景下都是正确的。
    // 但是会碰到一种场景：如选择组件，选择组件里面的每个选项的 value 是由数字组成的字符串，那么这里强行转换就会出问题了。
    // 所以，如果碰到该场景，就要在每个业务里面自己写一个 _cookQuery 函数去覆盖掉 searchMixin 的 _cookQuery  函数。
    // 这里不要对特殊场景做兼容，在每个业务单独去处理。
    _.each(query, (value, key) => {
      // 只有数字的字符串
      // 如果是 1 - 9 起始的数字字符串，将其转换为数字。以 0 起始的不转换，因为可能真的是要搜索 0 起始的字符串
      if (_.isString(value) && isNumber(value)) {
        query[key] = Number(value)
      }

      // 数组且每一项都是只有数字的字符串
      if (
        _.isArray(value) &&
        value.every((item) => _.isString(item) && isNumber(item))
      ) {
        query[key] = value.map((item) => Number(item))
      }
    })
    return query
  }

  /**
   * 搜索组件默认的mounted事件
   * 如果存在特殊业务，自行重写该方法
   */
  _searchMounted(): void {
    const routeQuery: SearchQuery = { ...this.$route.query }

    // 处理多级联动组件数据
    _.each(routeQuery, (value, key) => {
      if (_.isArray(value)) {
        routeQuery[key] = value.map((item) => {
          // 如果值的每一项是 1,2,3 这种数据格式，则默认将其转为数组以便兼容多级联动组件
          if (item.split(',').length > 1) {
            return item.split(',').map((str: number | string) => Number(str))
          }
          return item
        })
      }
    })

    // 如果 URL 上的参数值为字符串（多选的控件只选了一个选项），但是定义的类型的数组，那么将字符串改为数组
    _.each(this.query, (value, key) => {
      if (_.isArray(value) && _.isString(routeQuery[key])) {
        routeQuery[key] = [routeQuery[key]]
      }
    })

    this.query = this._cookQuery(Object.assign({}, this.query, routeQuery))
    this.cloneQuery = { ...this.query }
  }
}
